<template>
  <div v-if="mainfunc" v-loading="loading">
    <!-- <div v-if="mainfunc.paraIndexSolo" class="asTit">{{ (parseInt(mainfunc.paraIndexSolo) + 1) + ' - ' + mainfunc.dts.name }}</div> -->
    <!-- <div v-if="operationTit.substr(-4) ===$t('参数修改')">
      <div v-if="mainfunc.paraIndexSolo" class="asTit">
        {{ (parseInt(mainfunc.paraIndexSolo) + 1) + ' - ' + mainfunc.dts.name }}
      </div>
      <div v-else class="asTit">
        {{ dataIndex || parseInt(dataIndex) === 0 ? (parseInt(mainfunc.dataIndex) + 2) + ' - ' + mainfunc.dts.name : mainfunc.dts.name }}
      </div>
    </div> -->
    <div v-if="!(operationTit.substr(-4) ===$t('参数修改'))">
      <el-link
        v-if="mainfunc.paraIndexSolo"
        icon="el-icon-back"
        class="asTit"
        :underline="false"
        @click="goBack"
      >
        {{ (parseInt(mainfunc.paraIndexSolo) + 1) + ' - ' + mainfunc.dts.name }}
      </el-link>
      <el-link
        v-else
        icon="el-icon-back"
        class="asTit"
        @click="goBack"
      >
        {{ dataIndex || parseInt(dataIndex) === 0 ? (parseInt(mainfunc.dataIndex) + 2) + ' - ' + mainfunc.dts.name : mainfunc.dts.name }}
      </el-link>
    </div>
    <v-scrollbar v-el-init-h="168" settings="settings" class="funcsForm">
      <!-- :key="new Date().getTime()" :btn-items="btns" -->
      <formQuery
        :key="new Date().getTime()"
        ref="mainForm"
        :form-options="formOptions"
        :is-inline="false"
        class="mainForm"
        @onConfirm="onConfirm"
        @cancel="onCancel"
        @onValidate="onValidate"
      >
        <!-- <div slot="formItemInner">
          <div>
            <div>
              <el-input v-model="switchInputVal" :disabled="switchValue === 'on'" class="simuInput" />
              <el-switch
                v-model="switchValue"
                active-color="#409EFF"
                inactive-color="#909399"
                active-value="on"
                inactive-value="off"
              />
            </div>
          </div>
          <div v-show="switchValue !== 'off'">
            <el-radio-group v-model="switchRadioValue" size="mini" @change="switchRadioChange">
              <el-radio v-for="item in switchOptions" :key="item.value" :label="item.value.toString()">{{ item.label }}</el-radio>
            </el-radio-group>
          </div>
        </div> -->
      </formQuery>
    </v-scrollbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'MainInfo',
  components: {},
  data() {
    return {
      hasDif: 0,
      loading: true,
      yesNo: '',
      ynTag: '',
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false
      },
      formOptions: [],
      actValList: [],
      switchTag: '',
      // btns: '',
      oldVal: '',
      switchInputVal: '',
      switchValue: 'off',
      switchOptions: [],
      switchRadioValue: '',
      this3index: '',
      fixedData: '',
      originalCopy: '',
      clickedBtn: '',
      origins: '',
      noRepeatMake: true,
      funcFixed: {},
      oldMainFunc: '',
      mainfunc: '',
      dataIndex: '',
      ctrMark: ''
    };
  },
  computed: {
    ...mapState('monitorDetails', {
      operationTit: state => state.operationTit,
      batchRecords: state => state.batchRecords
    }),
    ...mapState('process', {
      mainfuncFunc: state => state.mainfunc,
      isCopied: state => state.isCopied,
      clickedPara: state => state.clickedPara
    })
    // ...mapState('user', {
    //   btnClicked: state => state.btnClicked
    // })
  },
  watch: {
    btnClicked: {
      handler(newVal, oldVal) {
        console.log('vvv0', newVal);
        if (newVal) {
          this.clickedBtn = newVal;
        }
      },
      deep: true,
      immediate: false
    }
    // mainfunc: {
    //   handler(newVal, oldVal) {
    //     setTimeout(() => {
    //       this.makeForms(newVal.dts);
    //     }, 200);
    //   },
    //   deep: true,
    //   immediate: false
    // }
    // 监听当前操作的是主功能还是并行功能
    // mainfunc: {
    //   handler(newVal, oldVal) {
    //     console.log('newVal', newVal)
    //     this.loading = true
    //     this.makeFormsOuter(newVal)
    //     // this.mainFormConfirm(null, 'original')
    //     // const { dts } = this.oldMainFunc
    //     // const { acknowledge } = dts
    //     // if ((this.oldMainFunc.paraIndex || parseInt(this.oldMainFunc.paraIndex) === 0) && acknowledge === 2) {
    //     //   // console.log('!!!!!')
    //     //   this.$confirm(this.$t('是否将修改覆盖到下面相同的步骤\?'), this.$t('提示'), {
    //     //     confirmButtonText: this.$t('是'),
    //     //     cancelButtonText: this.$t('否'),
    //     //     type: 'warning'
    //     //   }).then(() => {
    //     //     this.$store.dispatch('process/markdownCopied', 'yes')
    //     //     this.passFuncs(this.funcFixed, 'yes')
    //     //     this.makeFormsOuter(newVal)
    //     //   }).catch(() => {
    //     //     this.$store.dispatch('process/markdownCopied', 'no')
    //     //     this.passFuncs(this.funcFixed, 'no')
    //     //     this.makeFormsOuter(newVal)
    //     //   })
    //     // } else {
    //     //   this.$store.dispatch('process/markdownCopied', this.isCopied)
    //     //   // console.log('??????!')
    //     //   this.passFuncs(this.funcFixed, 'no')
    //     //   this.makeFormsOuter(newVal)
    //     // }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  created() {},
  mounted() {
    this.ctrMark = localStorage.getItem('architectureController');
    window.addEventListener('keydown', this.enterCallback);
    // this.changeViews(null)
    this.$eventBus.$on('btnClicked', (val) => {
      this.clickedBtn = val;
    });
    this.$eventBus.$on('simuPass', (val) => {
      this.mainFormConfirm(null, 'original', val);
    });
    this.$eventBus.$on('changeMainFunc', (val) => {
      // console.log('changeMainFunc', val);
      this.yesNo = null;
      const { parameters, funcParameter } = val.dts;
      let parametersList = '';
      if (parameters) {
        parametersList = parameters.map((value, i) => ({
          ...value,
          name: value.parametersChinaName
        }));
      } else {
        parametersList = funcParameter.map((value, i) => ({
          ...value,
          name: value.groupName || value.name
        }));
      }
      this.hasDif = 0;
      // this.mainfunc = val
      this.mainfunc = { ...val, dts: { name: val.dts.name, parameters: parametersList }};
      // console.log('this.mainfunc', this.mainfunc);
      this.loading = true;
      this.makeFormsOuter({ ...val, dts: { name: val.dts.name, parameters: parametersList }});
    });
    // console.log('？？？？')
    // this.$eventBus.$on('funcPara', (val) => {
    //   const { dts } = this.oldMainFunc
    //   const { acknowledge } = dts
    //   if ((this.oldMainFunc.paraIndex || parseInt(this.oldMainFunc.paraIndex) === 0) && acknowledge === 2) {
    //     // console.log('!!!!!')
    //     this.$confirm(this.$t('是否将修改覆盖到下面相同的步骤\?'), this.$t('提示'), {
    //       confirmButtonText: this.$t('是'),
    //       cancelButtonText: this.$t('否'),
    //       type: 'warning'
    //     }).then(() => {
    //       this.$store.dispatch('process/markdownCopied', 'yes')
    //       this.passFuncs(this.funcFixed, 'yes')
    //     }).catch(() => {
    //       this.$store.dispatch('process/markdownCopied', 'no')
    //       this.passFuncs(this.funcFixed, 'no')
    //     })
    //   } else {
    //     this.$store.dispatch('process/markdownCopied', this.isCopied)
    //     // console.log('??????!')
    //     this.passFuncs(this.funcFixed, 'no')
    //   }
    //   this.funcFixed = {}
    // })
    // const { dts } = this.mainfunc
    // const { parameters, fixedList } = dts
    // // parameters.forEach((i, ind) => {
    // //   const asKey = (i.paramID + '-' + i.name + '-' + i.unit + '-' + i.dataType + '-' + ind + '-' + i.defValue + '-' + i.defcheckboxList).toString()
    // //   if (i.dataType !== 4) {
    // //     this.funcFixed[asKey] = parseFloat(i.actValues)
    // //   } else {
    // //     this.funcFixed[asKey] = i.checkboxList || i.defcheckboxList
    // //   }
    // // })
    // this.mainFormConfirm(null, 'original')
    // // this.oldMainFunc = this.mainfunc
    // this.oldVal = dts.parameters
    // // const copyData = JSON.parse(JSON.stringify(dts))
    // // const test4 = {
    // //   checkboxList: [1, 2],
    // //   defcheckboxList: [1, 2, 3],
    // //   dataType: 4,
    // //   defValue: 1,
    // //   maxValue: 10000,
    // //   minValue: 0,
    // //   name: this.$t('入水阀选择'),
    // //   paramID: 100,
    // //   parametersId: 100,
    // //   parametersName: this.$t('入水阀选择'),
    // //   showValues: 'checbox',
    // //   textParamGroup: [
    // //     {
    // //       name: this.$t('入水1阀'),
    // //       value: 1
    // //     },
    // //     {
    // //       name: this.$t('入水2阀'),
    // //       value: 2
    // //     },
    // //     {
    // //       name: this.$t('入水3阀'),
    // //       value: 3
    // //     },
    // //     {
    // //       name: this.$t('入水4阀'),
    // //       value: 4
    // //     }
    // //   ],
    // //   unit: ''
    // // }
    // // const paras = parameters.push(test4)
    // // const dtsSimu = {
    // //   ...dts,
    // //   parameters: paras
    // // }
    // // setTimeout(() => {\

    // // const switchIndex = dts.parameters.findIndex(i => {
    // //   return i.name === this.$t('使用批次参数')
    // // })
    // const oriList = []
    // const fixedListNew = []
    // parameters.forEach(i => {
    //   let anObj = {}
    //   let fixedObj = {}
    //   if (i.name !== this.$t('使用批次参数')) {
    //     fixedObj = {
    //       ...i,
    //       actValues: i.actValues,
    //       disabled: 'disabled',
    //       checkboxList: i.checkboxList && i.checkboxList.length > 0 ? i.checkboxList : i.defcheckboxList && i.defcheckboxList.length > 0 ? i.defcheckboxList : []
    //     }
    //     anObj = {
    //       ...i,
    //       actValues: i.actValues,
    //       disabled: 'disabled',
    //       checkboxList: i.checkboxList && i.checkboxList.length > 0 ? i.checkboxList : i.defcheckboxList && i.defcheckboxList.length > 0 ? i.defcheckboxList : []
    //     }
    //   } else {
    //     fixedObj = {
    //       ...i,
    //       actValues: 0,
    //       disabled: null,
    //       checkboxList: i.checkboxList && i.checkboxList.length > 0 ? i.checkboxList : i.defcheckboxList && i.defcheckboxList.length > 0 ? i.defcheckboxList : []
    //     }
    //     anObj = {
    //       ...i,
    //       actValues: 1,
    //       disabled: null,
    //       checkboxList: i.defcheckboxList
    //     }
    //   }
    //   oriList.push(anObj)
    //   fixedListNew.push(fixedObj)
    // })

    // this.origins = {
    //   ...dts,
    //   parameters: oriList
    // }

    // let temDt = ''
    // if (fixedList) {
    //   temDt = {
    //     ...dts,
    //     parameters: fixedList
    //   }
    // } else {
    //   temDt = {
    //     ...dts,
    //     parameters: fixedListNew
    //   }
    // }
    // this.fixedData = JSON.parse(JSON.stringify(temDt))
    // // console.log('origins', this.origins)
    // dts.parameters.forEach((i, ind) => {
    //   if (i.dataType === 3) {
    //     if (!/[\u4E00-\u9FA5]/g.test(i.showValues)) {
    //       i['switchTag'] = 'off'
    //     } else {
    //       i['switchTag'] = 'on'
    //     }
    //   }

    //   // if (switchIndex > -1) {
    //   //   console.log('i', i)
    //   //   if (parseInt(dts.parameters[switchIndex].actValues) === 1 || (!dts.parameters[switchIndex].actValues && parseInt(dts.parameters[switchIndex].defValue) === 1)) {
    //   //     if (parseInt(ind) !== parseInt(switchIndex)) {
    //   //       i['disabled'] = 'disabled'
    //   //     }
    //   //   } else {
    //   //     i['disabled'] = null
    //   //   }
    //   // }
    // })
    // // console.log('copyData', dts)
    // if (parameters.length > 0) {
    //   // console.log('copyData', dts)
    //   this.makeForms(dts)
    //   this.btns = 'confirm'
    // } else {
    //   // 避免没有参数的情况下也出现确认按钮
    //   this.formOptions = []
    //   this.btns = ''
    // }
    // }, 500)
  },
  methods: {
    // 返回
    goBack() {
      this.$emit('goBack', true);
      if (this.operationTit !== this.$t('添加并行功能')) this.$store.dispatch('monitorDetails/markdownOpers', this.$t('插入步骤-第一步：选择功能'));
    },
    onValidate(b) {
      this.$eventBus.$emit('validTag', b);
    },
    addEnterListener() {
      if (window.__completeEnterBind__) return;
      window.addEventListener('keydown', this.enterCallback);
      window.__completeEnterBind__ = true;
    },
    removeEnterListener() {
      window.removeEventListener('keydown', this.enterCallback);
      window.__completeEnterBind__ = false;
    },
    findFormItem(el) {
      const parent = el.parentElement;
      if (!parent) return document.body;
      if (
        parent.className.includes('form-item')
      ) {
        console.log('paran', parent);
        return parent;
      }
      // if (
      //   parent.className.includes('el-form-item') &&
      //   parent.className.includes('el-form-item--medium')
      // ) {
      //   return parent
      // }
      return this.findFormItem(parent);
    },
    enterCallback(e) {
      if (e.keyCode === 13) {
        const container = this.findFormItem(document.activeElement);
        console.log('container', container);
        this.findInput(container) && this.findInput(container).focus();
      }
    },
    findInput(container) {
      let nextEl = container.nextElementSibling;
      if (!nextEl) return;
      let input = nextEl.querySelector('input');
      console.log('inttt', input);
      while (input.id === 'el-select') {
        nextEl = nextEl.nextElementSibling;
        if (!nextEl) return;
        input = nextEl.querySelector('input');
      }
      if (input.className.includes('el-input__inner')) return input;
    },
    makeFormsOuter(val) {
      console.log('makeFormsOuter', val);
      setTimeout(() => {
        const { dts } = val;
        //  fixedList
        const { parameters } = dts;
        // parameters.forEach((i, ind) => {
        //   const asKey = (i.paramID + '-' + i.name + '-' + i.unit + '-' + i.dataType + '-' + ind + '-' + i.defValue + '-' + i.defcheckboxList).toString()
        //   if (i.dataType !== 4) {
        //     this.funcFixed[asKey] = i.actValues
        //   } else {
        //     this.funcFixed[asKey] = i.checkboxList || i.defcheckboxList
        //   }
        // })
        // const oriList = []
        // const fixedListNew = []
        // console.log('dys', dts)
        // parameters.forEach(i => {
        //   let fixedObj = {}
        //   let anObj = {}
        //   if (i.name !== this.$t('使用批次参数')) {
        //     fixedObj = {
        //       ...i,
        //       actValues: i.defValue,
        //       disabled: 'disabled',
        //       checkboxList: i.defcheckboxList
        //     }
        //     anObj = {
        //       ...i,
        //       actValues: i.defValue,
        //       disabled: 'disabled',
        //       checkboxList: i.defcheckboxList
        //     }
        //   } else {
        //     fixedObj = {
        //       ...i,
        //       actValues: 0,
        //       disabled: null,
        //       checkboxList: i.defcheckboxList
        //     }
        //     anObj = {
        //       ...i,
        //       actValues: 1,
        //       disabled: null,
        //       checkboxList: i.defcheckboxList
        //     }
        //   }
        //   fixedListNew.push(fixedObj)
        //   oriList.push(anObj)
        // })

        // this.origins = {
        //   ...dts,
        //   parameters: oriList
        // }
        // let temDt = ''
        // if (fixedList) {
        //   temDt = {
        //     ...this.mainfunc.dts,
        //     parameters: fixedList
        //   }
        // } else {
        //   temDt = {
        //     ...this.mainfunc.dts,
        //     parameters: fixedListNew
        //   }
        // }
        // this.fixedData = JSON.parse(JSON.stringify(temDt))
        // console.log('origins', this.origins)
        this.oldVal = parameters;
        // console.log('mians', this.oldVal)
        if (parameters.length > 0) {
          this.makeForms(dts);
          this.btns = 'confirm';
        } else {
          // 避免没有参数的情况下也出现确认按钮
          this.formOptions = [];
          this.btns = '';
          this.loading = false;
        }
      }, 200);
    },
    makeFormat(dt) {
      const formatList = [];
      var temObj = {};
      dt.forEach(item => {
        if (parseInt(item.groupIndex) === 0 && parseInt(item.groupFlag) > 0) {
          if (!temObj[item.groupFlag]) {
            temObj[item.groupFlag] = item;
          }
        }
      });
      clearTimeout();
      setTimeout(() => {
        dt.forEach(item => {
          if (parseInt(item.groupFlag) === 0 && parseInt(item.groupIndex) > 0) {
            // console.log('yyyyi', temObj)
            for (var key in temObj) {
              if (parseInt(key) === parseInt(item.groupIndex)) {
                if (!temObj[key]['children']) {
                  temObj[key]['children'] = [item];
                } else {
                  temObj[key]['children'].push(item);
                }
              }
            }
          }
        });
        for (var key in temObj) {
          formatList.push(temObj[key]);
        }
        console.log('formatList', formatList);
        return formatList;
      }, 100);
    },
    unique(arr, val) {
      const res = new Map();
      return arr.filter(item => !res.has(item[val]) && res.set(item[val], 1));
    },
    switchRadioChange(val) {
      console.log('val', val);
    },
    makeForms(dt = this.mainfunc.dts) {
      if (this.noRepeatMake) {
        // this.noRepeatMake = false
        console.log('mounted', dt);
        const self = this;
        // const { itemType } = dt
        // if (itemType.indexOf('itemFunc') > -1) {
        this.formOptions = [];
        if (dt && dt.parameters) {
          console.log('parass', dt);
          const { parameters } = dt;
          if (parameters) {
            const switchIndex = parameters.findIndex(i => {
              return i.name === this.$t('使用批次参数');
            });
            if (switchIndex > -1) {
              if (parseInt(parameters[switchIndex].actValue) === 1 || (!parameters[switchIndex].actValue && parseInt(parameters[switchIndex].defValue) === 1)) {
                parameters.forEach((o, ind) => {
                  o.disabled = null;
                  if (parseInt(ind) !== parseInt(switchIndex)) {
                    o.disabled = 'disabled';
                  }
                });
              } else {
                parameters.forEach((o, ind) => {
                  o.disabled = null;
                });
              }
            }
            const noRepeatParas = parameters[0]['paramID'] ? this.unique(parameters, 'paramID') : this.unique(parameters, 'id');
            console.log('dta', parameters);
            noRepeatParas.forEach((i, index) => {
              console.log('i', i);
              let anObj = {};
              var temOpts = '';
              var values = parseFloat(i.actValue) === 0 ? 0 : i.actValue ? i.actValue : parseFloat(i.defValue) === 0 ? 0 : i.defValue;
              // console.log('valuess', i);
              // 判断 showValues为中文的时候则默认switch打开，否则关闭
              if (!/[\u4E00-\u9FA5]/g.test(i.showValues)) {
                i['switchTag'] = 'off';
              } else {
                i['switchTag'] = 'on';
              }
              switch (parseInt(i.dataType)) {
                // input
                case 0:
                  anObj = {
                    label: i.name || i.parametersChinaName,
                    prop: i.paramNo + '-' + (i.name || i.parametersChinaName) + '-' + i.unit + '-' + i.dataType + '-' + index + '-' + i.batchParamId,
                    element: 'el-input',
                    disable: i.disabled,
                    initValue: values,
                    notVisibleCons: this.ctrMark === '1' && i.minValue && i.minValue === '0' && i.maxValue && i.maxValue === '0',
                    rules: this.yesNo === 'yes' ? null : [
                      { validator: (rule, value, callback) => {
                        this.$verify.isNum(rule, value, callback, i.minValue, i.maxValue, i.keepDecimal);
                      }, trigger: 'input' }],
                    events: {
                      blur(val) {
                        self.mainFormConfirm(null, 'original');
                      }
                    }
                  };
                  break;
                case 1:
                  // 选项
                  this.actValList[index] = i.textParamGroup;
                  temOpts = i.textParamGroup.map((val, i) => ({
                    label: val.chinaName,
                    value: val.value
                  }));
                  // console.log('i.textParamGroup', i.textParamGroup)
                  if ((!i.textParamGroup[0]['groupFlag'] && !i.textParamGroup[0]['groupIndex']) || parseInt(i.textParamGroup[0]['groupFlag']) === 0 && parseInt(i.textParamGroup[0]['groupIndex']) === 0) {
                    anObj = {
                      label: i.name || i.parametersChinaName,
                      prop: i.paramNo + '-' + (i.name || i.parametersChinaName) + '-' + i.unit + '-' + i.dataType + '-' + index + '-' + i.batchParamId + '-' + i.defValue,
                      element: 'el-radio',
                      initValue: parseFloat(i.actValues) === 0 ? 0 : i.actValues ? i.actValues : parseFloat(i.actValue) === 0 ? 0 : parseFloat(i.actValue),
                      options: temOpts,
                      disable: i.disabled,
                      events: {
                        change(val) {
                          console.log('val', val);
                          if (i.name === this.$t('使用批次参数')) {
                            // console.log('1111', val)
                            if (val === 1) {
                              // self.$eventBus.$emit('btnClicked', 'otherplaces')
                              self.mainFormConfirm('yes');
                              console.log('1111');
                              // self.mainfunc.dts = JSON.parse(JSON.stringify(self.origins))
                              // self.mainfunc.dts.parameters.forEach(item => {
                              //   if (item.name !== this.$t('使用批次参数')) {
                              //     item.disabled = 'disabled'
                              //   } else {
                              //     item.actValues = 1
                              //   }
                              // })
                              // self.makeForms(self.origins)
                              // console.log('222222', JSON.parse(JSON.stringify(self.origins)))
                            } else {
                              // self.$eventBus.$emit('btnClicked', 'otherplaces')
                              self.mainFormConfirm('no');
                              console.log('222');
                              // console.log('dts', JSON.parse(JSON.stringify(self.fixedData)))
                              // self.mainfunc.dts = JSON.parse(JSON.stringify(self.fixedData))
                              // self.makeForms(self.mainfunc.dts)
                              // self.mainfunc.dts.parameters.forEach(item => {
                              //   item.disabled = null
                              //   if (item.name === this.$t('使用批次参数')) {
                              //     item.actValues = 0
                              //   }
                              // })
                            }
                            // console.log('dts', self.mainfunc.dts, self.fixedData)
                            // self.makeForms(self.mainfunc.dts)
                          } else {
                            self.mainFormConfirm(null, 'original');
                          }
                        }
                      }
                    };
                  } else {
                    const formatList = [];
                    var temObj = {};
                    i.textParamGroup.forEach(item => {
                      if (parseInt(item.groupIndex) === 0 && parseInt(item.groupFlag) > 0) {
                        if (!temObj[item.groupFlag]) {
                          temObj[item.groupFlag] = item;
                        }
                      }
                    });
                    clearTimeout();
                    setTimeout(() => {
                      for (var key in temObj) {
                        temObj[key]['children'] = [];
                        i.textParamGroup.forEach(item => {
                          if (parseInt(item.groupFlag) === 0 && parseInt(item.groupIndex) > 0 && parseInt(key) === parseInt(item.groupIndex)) {
                            if (!temObj[key]['children']) {
                              temObj[key]['children'] = [item];
                            } else {
                              temObj[key]['children'].push(item);
                            }
                          }
                        });
                        formatList.push(temObj[key]);
                      }
                      // i.textParamGroup.forEach(item => {
                      //   if (parseInt(item.groupFlag) === 0 && parseInt(item.groupIndex) > 0) {
                      //     // console.log('yyyyi', temObj)
                      //     for (var key in temObj) {
                      //       if (parseInt(key) === parseInt(item.groupIndex)) {
                      //         if (!temObj[key]['children']) {
                      //           temObj[key]['children'] = [item]
                      //         } else {
                      //           temObj[key]['children'].push(item)
                      //         }
                      //       }
                      //     }
                      //   }
                      // })
                      // for (var key in temObj) {
                      //   formatList.push(temObj[key])
                      // }
                      // console.log('formatList', formatList)
                    }, 100);
                    console.log('temOpts', formatList);
                    anObj = {
                      label: i.name || i.parametersChinaName,
                      prop: i.paramNo + '-' + (i.name || i.parametersChinaName) + '-' + i.unit + '-' + i.dataType + '-' + index + '-' + i.batchParamId + '-' + i.defValue,
                      element: 'el-radio-groups',
                      initValue: values > i.textParamGroup.length ? 0 : parseFloat(values),
                      options: formatList,
                      disable: i.disabled,
                      events: {
                        change(val) {
                          // console.log('valll', val)
                          if (i.name === this.$t('使用批次参数')) {
                            if (val === 1) {
                              self.mainFormConfirm();
                              self.mainfunc.dts.parameters.forEach(item => {
                                if (item.name !== this.$t('使用批次参数')) {
                                  item.disabled = 'disabled';
                                } else {
                                  item.actValues = 1;
                                }
                              });
                            } else {
                              // console.log('222222')
                              self.mainfunc.dts.parameters.forEach(item => {
                                item.disabled = null;
                                if (item.name === this.$t('使用批次参数')) {
                                  item.actValues = 0;
                                }
                              });
                            }
                            // console.log('dts', self.mainfunc.dts)
                            self.makeForms(self.mainfunc.dts);
                          } else {
                            self.mainFormConfirm(null, 'original');
                          }
                        }
                      }
                    };
                  }
                  break;
                case 3:
                  temOpts = i.textParamGroup.map((val, i) => ({
                    label: val.chinaName,
                    value: val.value
                  }));
                  // console.log('temOpts', temOpts);
                  this.actValList[index] = i.textParamGroup;
                  // // 选项加input
                  // this.this3index = index
                  // this.actValList[index] = i.textParamGroup
                  // anObj = {
                  //   label: i.name,
                  //   prop: i.paramID + '-' + i.name + '-' + i.unit + '-' + i.dataType + '-' + index + '-' + i.defValue,
                  //   element: 'el-input',
                  //   slot: true,
                  //   slotName: 'formItemInner'
                  // }
                  // this.switchInputVal = values
                  // // console.log('aaaa', this.actValList)
                  // // var initSwitch = parseFloat(values) > 100 ? parseFloat(values - 100) : values > i.textParamGroup.length ? 0 : values
                  // // this.mainfunc.dts.parameters[index]['switchTag'] = initSwitch === 0 ? 'off' : 'on'
                  // if (this.switchOptions && this.switchOptions.length > 0) {
                  //   this.switchRadioValue = values
                  // }
                  // this.switchValue = i.switchTag || 'off'
                  var makeAct = 'test';
                  console.log('33333', i.showValues, i.parametersName, i.parametersChinaName);
                  if (i.parametersName === this.$t('总量') || i.parametersName === this.$t('主缸水量') || i.parametersName === this.$t('洗水总量') || i.parametersChinaName === this.$t('总量') || i.parametersName === this.$t('水量') || i.parametersChinaName === this.$t('主缸水量') || i.parametersChinaName === this.$t('洗水总量') || i.parametersChinaName === this.$t('水量')) {
                    const chiTest = /[\u4E00-\u9FA5]/g.test(i.showValues);
                    if (!chiTest) {
                      makeAct = parseFloat(i.showValues);
                    }
                  }
                  console.log('makeAct', makeAct, i, parseInt(values));
                  anObj = {
                    label: i.name || i.parametersChinaName,
                    prop: i.paramNo + '-' + (i.name || i.parametersChinaName) + '-' + i.unit + '-' + i.dataType + '-' + index + '-' + i.batchParamId + '-' + i.defValue,
                    element: 'el-switch-radio',
                    // initValue: parseInt(values) > 100 ? parseInt(values) - 100 : values > i.textParamGroup.length ? 0 : values,
                    options: temOpts,
                    switchValue: i.switchTag || 'off',
                    disable: i.disabled,
                    initValue: makeAct === 'test' ? parseInt(values) : makeAct.toString(),
                    rules: [
                      { validator: (rule, value, callback) => {
                        this.$verify.canVerify(rule, value, callback, i.switchTag);
                      }, trigger: 'change' }, { validator: (rule, value, callback) => {
                        this.$verify.canVerify(rule, value, callback, i.switchTag);
                      }, trigger: 'blur' }],
                    events: {
                      change(val) {
                        console.log('vhangeval', val);
                        if (val === 'off') {
                          self.mainfunc.dts.parameters[index]['switchTag'] = 'off';
                        } else {
                          self.mainfunc.dts.parameters[index]['switchTag'] = 'on';
                        }
                        // if (self.mainfunc.dts.parameters[index]['switchTag'] === 'off') {
                        //   self.mainfunc.dts.parameters[index]['switchTag'] = 'on'
                        // } else {
                        //   self.mainfunc.dts.parameters[index]['switchTag'] = 'off'
                        // }
                        self.mainFormConfirm(null, 'original');
                      },
                      input(val) {
                        console.log('input', val);
                        self.mainfunc.dts.parameters[index]['switchTag'] = 'off';
                        self.mainFormConfirm(null, 'original');
                      }
                    }
                  };
                  break;
                case 4:
                  // 选项
                  this.actValList[index] = i.textParamGroup;
                  temOpts = i.textParamGroup.map((val, i) => ({
                    label: val.chinaName,
                    value: val.value
                  }));
                  anObj = {
                    label: i.name || i.parametersChinaName,
                    prop: i.paramNo + '-' + (i.name || i.parametersChinaName) + '-' + i.unit + '-' + i.dataType + '-' + index + '-' + i.batchParamId + '-' + i.defValue + '-' + i.defcheckboxList,
                    element: 'el-checkbox',
                    initValue: i.checkboxList || i.defcheckboxList,
                    options: temOpts,
                    disable: i.disabled,
                    rules: i.parametersChinaName === this.$t('助剂') ? [{ validator: (rule, value, callback) => {
                      this.$verify.max4(rule, value, callback);
                    }, trigger: 'blur' }] : [{ type: 'array', required: true, message: this.$t('请至少选择一项'), trigger: 'change' }],
                    events: {
                      change(val) {
                        self.mainFormConfirm(null, 'original');
                      }
                    }
                  };
                  break;
                case 6:
                  // temInitValues = '';
                  // if (parseFloat(i.showValues) >= 10 && parseFloat(i.actValue) !== parseFloat(i.showValues)) {
                  //   temInitValues = parseFloat(i.showValues) - 10;
                  // } else if (parseFloat(i.showValues) < 10) {
                  //   temInitValues = parseFloat(i.showValues);
                  // }
                  // self.mainfunc.dts.parameters[index]['openFlag'] = !!i.openFlag;
                  self.mainfunc.dts.parameters[index]['switchTag'] = i.openFlag ? 'on' : 'off';
                  self.mainfunc.dts.parameters[index]['originalShowValue'] = i.showValues;
                  anObj = {
                    label: i.name || i.parametersName || i.parametersChinaName,
                    prop: i.paramNo + '-' + (i.name || i.parametersName || i.parametersChinaName) + '-' + i.unit + '-' + i.dataType + '-' + index + '-' + i.batchParamId + '-' + i.defValue,
                    element: 'el-switch-input',
                    // initValue: parseInt(values) > 100 ? parseInt(values) - 100 : values > i.textParamGroup.length ? 0 : values,
                    initValue: values.toString(),
                    switchValue: i.openFlag ? 'on' : 'off',
                    disable: i.openFlag ? 'disabled' : null,
                    rules: [
                      { required: true, message: this.$t('请输入'), trigger: 'blur' },
                      { validator: (rule, value, callback) => {
                        this.$verify.isNum(rule, value, callback, i.minValue, i.maxValue, i.keepDecimal);
                      }, trigger: 'blur' }
                    ],
                    events: {
                      change(val) {
                        self.mainfunc.dts.parameters[index]['switchTag'] = val === 'off' ? 'off' : 'on';
                        self.mainfunc.dts.parameters[index]['openFlag'] = val !== 'off';
                        console.log('changeVal', self.mainfunc.dts.parameters[index]['openFlag']);
                        self.mainFormConfirm(null, 'original');
                      },
                      input(val) {
                        // console.log('inputVal', val);
                        self.mainFormConfirm(null, 'original');
                        self.mainfunc.dts.parameters[index]['originalShowValue'] = val;
                      }
                    }
                  };
                  break;
                case 5:
                  if (i.textParamGroup.length > 0) {
                    temOpts = i.textParamGroup.map(val => ({
                      label: val.chinaName,
                      value: val.value
                    }));
                    this.actValList[index] = i.textParamGroup;
                  }
                  self.mainfunc.dts.parameters[index]['switchTag'] = i.openFlag ? 'on' : 'off';
                  // self.mainfunc.dts.parameters[index]['openFlag'] = !!i.openFlag;
                  // temInitValues = '';
                  // if (parseFloat(i.showValues) >= 10 && parseFloat(i.actValue) !== parseFloat(i.showValues)) {
                  //   temInitValues = parseFloat(i.showValues) - 10;
                  // } else if (parseFloat(i.showValues) < 10) {
                  //   temInitValues = parseFloat(i.showValues);
                  // }
                  anObj = {
                    label: i.name || i.parametersName || i.parametersChinaName,
                    prop: i.paramNo + '-' + (i.name || i.parametersName || i.parametersChinaName) + '-' + i.unit + '-' + i.dataType + '-' + index + '-' + i.batchParamId + '-' + i.defValue,
                    element: 'el-switch-r',
                    // initValue: parseInt(values) > 100 ? parseInt(values) - 100 : values > i.textParamGroup.length ? 0 : values,
                    initValue: values.toString(),
                    options: temOpts || [],
                    switchValue: i.openFlag ? 'on' : 'off',
                    disable: i.openFlag ? 'disabled' : null,
                    events: {
                      change(val) {
                        console.log('changeVal', val);
                        self.mainfunc.dts.parameters[index]['switchTag'] = val;
                        self.mainfunc.dts.parameters[index]['openFlag'] = val !== 'off';
                        self.mainFormConfirm(null, 'original');
                      }
                    }
                  };
                  break;
                default:
                  console.log('dataType', i.dataType);
              }
              this.formOptions.push(anObj);
            });
            console.log('acval', this.formOptions);
          }
        }
      }
      clearTimeout();
      setTimeout(() => {
        // this.loading = false
        this.noRepeatMake = true;
        this.mainFormConfirm(null, 'original');
      }, 300);
      // } else {
      //   console.log('dt', dt)
      // }
    },
    mainFormConfirm(tag, asBtn, ynTag) {
      const self = this;
      this.yesNo = tag;
      this.ynTag = ynTag;
      this.$store.dispatch('process/markdownClickedPara', 'inner');
      // this.$refs.mainForm.onConfirm()
      clearTimeout();
      setTimeout(() => {
        if (this.$refs.mainForm) {
          this.$refs.mainForm.onConfirm();
        }
        // this.$refs.mainForm.onConfirm()
        if (asBtn) {
          self.$eventBus.$emit('btnClicked', 'original');
        } else {
          self.$eventBus.$emit('btnClicked', 'otherplaces');
        }
        // if (tag === 'yes') {
        //   self.mainfunc.dts.parameters.forEach(item => {
        //     if (item.name !== this.$t('使用批次参数')) {
        //       item.disabled = 'disabled';
        //     } else {
        //       item.actValues = 1;
        //     }
        //   });
        // } else {
        //   self.mainfunc.dts.parameters.forEach(item => {
        //     item.disabled = null;
        //     if (item.name === this.$t('使用批次参数')) {
        //       item.actValues = 0;
        //     }
        //   });
        // }
        // this.$eventBus.$emit('btnClicked', 'otherplaces')
        // self.makeForms()
        this.loading = false;
      }, 600);
    },
    passFuncs(val, tag) {
      console.log('apsss', val, this.oldVal);
      const paraList = [];
      for (const key in val) {
        const keyList = key.split('-');
        const parametersId = keyList[0];
        const parametersName = keyList[1];
        const compaIndex = this.oldVal.findIndex(i => {
          return i.parametersChinaName === parametersName;
        });
        const unit = keyList[2];
        const dataType = keyList[3];
        const actValues = val[key];
        const ind = keyList[4];
        // const defVal = keyList[5]
        // const devChecks = keyList[6]
        // const defValue3 = keyList[5]
        let showVals = '';
        // let actVals = '';
        let showIndex = '';
        switch (parseInt(dataType)) {
          case 0:
            showVals = actValues.toString();
            break;
          case 1:
            showIndex = this.actValList[ind].findIndex(i => {
              return i.value === actValues;
            });
            showVals = this.actValList[ind][showIndex].name;
            // console.log('this.actValList', this.actValList, actValues)
            // showVals = this.actValList[ind][actValues]
            break;
          case 3:
            // console.log('swtich', this.mainfunc.dts.parameters[ind])
            if (this.mainfunc.dts.parameters[ind]['switchTag'] === 'off') {
              showVals = actValues.toString();
            } else {
              // console.log('this.actValList[ind][showIndex]', this.actValList[ind])
              showIndex = this.actValList[ind].findIndex(i => {
                return parseFloat(i.value) === parseFloat(actValues);
              });
              console.log('this.actValList[ind][showIndex]', showIndex, this.actValList[ind]);
              showVals = showIndex > -1 ? this.actValList[ind][showIndex].name ? this.actValList[ind][showIndex].name : this.actValList[ind][showIndex].chinaName : actValues;
            }
            break;
          case 4:
            this.actValList[ind].forEach((i) => {
              actValues.forEach(x => {
                if (parseInt(i.value) === parseInt(x)) {
                  showVals += i.name + ',';
                }
              });
            });
            showVals = showVals.substring(0, showVals.lastIndexOf(','));
            // showIndex = this.actValList[ind].findIndex(i => {
            //   return i.value === actValues
            // })
            // showVals = this.actValList[ind][showIndex].name
            // console.log('4444', showVals)
            // showVals = this.actValList[ind][actValues]
            break;
          case 6:
            if (this.mainfunc.dts.parameters[ind]['switchTag'] === 'off') {
              showVals = actValues.toString();
              // actVals = parseFloat(actValues);
            } else {
              showVals = 'BP';
              // actVals = '0';
            }
            break;
          case 5:
            showIndex = this.actValList[ind].findIndex(i => {
              return i.value === parseFloat(actValues);
            });
            if (this.mainfunc.dts.parameters[ind]['switchTag'] !== 'on') {
              showVals = this.actValList[ind][showIndex].chinaName;
              // actVals = parseFloat(actValues);
            } else {
              showVals = 'BP';
              // actVals = '0';
            }
            break;
          default:
            console.log(showVals);
        }
        // console.log('showVlas', dataType, showVals);
        const finalShow = showVals?.name ? showVals.name : showVals;
        let anObj = {};
        if (parseInt(dataType) !== 4) {
          anObj = {
            openFlag: this.mainfunc.dts.parameters[ind]['openFlag'],
            parametersId: parseInt(parametersId),
            parametersName,
            actValues: parseFloat(actValues),
            showValues: finalShow,
            unit,
            dataType,
            // defValue: defVal,
            oldVal: (this.oldVal[compaIndex]['actValues'] || parseFloat(this.oldVal[compaIndex]['actValues']) === 0) ? parseFloat(this.oldVal[compaIndex]['actValues']) : 0
          };
          // console.log('?????', this.mainfunc.dts.parameters[ind]['switchTag'])
          if (parseInt(dataType) === 3) {
            if ((this.mainfunc.dts.parameters[ind]['switchTag'] && this.mainfunc.dts.parameters[ind]['switchTag'] === 'off')) {
              anObj = {
                ...anObj,
                switchTag: this.mainfunc.dts.parameters[ind]['switchTag']
              };
            } else if (!this.mainfunc.dts.parameters[ind]['switchTag']) {
              anObj = {
                ...anObj,
                switchTag: 'off'
              };
            }
          }
        } else {
          anObj = {
            parametersId: parseInt(parametersId),
            parametersName,
            actValues: parseFloat(actValues),
            checkboxList: actValues,
            showValues: finalShow,
            unit,
            dataType,
            // defValue: devChecks,
            oldVal: this.oldVal[compaIndex]['checkboxList'] || this.oldVal[compaIndex]['defcheckboxList']
          };
        }
        // console.log('this.mainfunc.dts.parameters', this.mainfunc.dts.parameters[ind])
        paraList.push(anObj);
      }
      // this.hasDif = 0
      // paraList.forEach(i => {
      //   if (i.checkboxList) {
      //     const a = i.checkboxList
      //     const b = i.defcheckboxList
      //     const arr = [...b].filter(x => [...a].every(y => y !== x))
      //     if (arr.length > 0) {
      //       this.hasDif += 1
      //     }
      //   } else {
      //     if (parseFloat(i.actValues) !== parseFloat(i.oldVal)) {
      //       this.hasDif += 1
      //     }
      //   }
      // })

      // this.oldVal = paraList
      // this.hasDif = 0
      // const temPara = JSON.parse(JSON.stringify(paraList))
      // if (Array.isArray(paraList)) {
      //   temPara.forEach(i => {
      //     if (i.checkboxList) {
      //       const a = new Set(i.checkboxList)
      //       const b = new Set(i.defcheckboxList)
      //       const arr = Array.from(new Set([...b].filter(x => !a.has(x))))
      //       if (arr.length > 0) {
      //         this.hasDif += 1
      //       }
      //     } else {
      //       if (parseFloat(i.actValues) !== parseFloat(i.oldVal)) {
      //         this.hasDif += 1
      //       }
      //     }
      //   })
      // } else {

      // }
      // console.log('tttt', paraList);
      this.$eventBus.$emit('parameters', { mainIndex: this.mainfunc.dataIndex, paraIndex: this.mainfunc.paraIndex, paraIndexSolo: this.mainfunc.paraIndexSolo, paraList, tag, name: this.mainfunc.dts.name, fixedData: this.fixedData || [], clickedTag: 'haveFixed' });
      // this.$Message(this.$t('已修改'), 'success', 500)
      clearTimeout();
      setTimeout(() => {
        if (tag === 'yes') {
          this.oldVal.forEach((o, ind) => {
            o.actValues = paraList[ind]['actValues'];
            if (paraList[ind].checkboxList) {
              o.checkboxList = paraList[ind].checkboxList;
            }
          });
          console.log('old', this.oldVal);
        }
      }, 1000);
    },
    onConfirm(val) {
      // const indexs = this.mainfunc.paraIndex.split('-')
      // console.log(this.clickedBtn)
      this.funcFixed = {};
      clearTimeout();
      setTimeout(() => {
        if (this.clickedBtn === 'original') {
          // this.$refs.mainForm.validate(valid => {
          console.log('11111111', val);
          //   if (valid) {
          if (this.ynTag !== 'yes') {
            this.passFuncs(val, 'no');
            this.funcFixed = val;
            this.oldMainFunc = this.mainfunc;
          } else {
            this.passFuncs(val, 'yes');
          }

          // const { dts, paraIndex } = this.mainfunc
          // const { acknowledge } = dts

          // if ((paraIndex || parseInt(paraIndex) === 0) && acknowledge === 2) {
          //   this.$confirm(this.$t('是否将修改覆盖到下面相同的步骤\?'), this.$t('提示'), {
          //     confirmButtonText: this.$t('是'),
          //     cancelButtonText: this.$t('否'),
          //     type: 'warning'
          //   }).then(() => {
          //     this.$store.dispatch('process/markdownCopied', 'yes')
          //     this.passFuncs(val, 'yes')
          //   }).catch(() => {
          //     this.$store.dispatch('process/markdownCopied', 'no')
          //     this.passFuncs(val, 'no')
          //   })
          // } else {
          //   this.$store.dispatch('process/markdownCopied', this.isCopied)
          //   this.passFuncs(val, 'no')
          // }
          //   }
          // })
        } else {
          const fixedList = [];
          for (const key in val) {
            const nameKey = key.split('-')[1];
            const bpIdKey = key.split('-')[5];
            const keyVal = val[key];
            const anObj = {
              nameKey,
              keyVal,
              bpIdKey
            };
            fixedList.push(anObj);
          }
          console.log('fixedlISR', fixedList);
          const copyList = JSON.parse(JSON.stringify(this.mainfunc.dts.parameters));
          if (this.yesNo === 'yes') {
            copyList.forEach((i, indx) => {
              if (i.name === fixedList[indx].nameKey) {
                const defaultBatchValue = this.batchRecords.batchParamList.find(o => {
                  return parseFloat(o.id) === parseFloat(fixedList[indx]['bpIdKey']);
                })?.value;
                console.log('defaultBatchValue', defaultBatchValue);
                if (i.name !== this.$t('使用批次参数')) {
                  i.disabled = 'disabled';
                  i.actValue = defaultBatchValue;
                  console.log(this.$t('不等于'), i.disabled);
                } else {
                  i.disabled = null;
                  i.actValue = 1;
                  i.showValues = this.$t('是');
                }
              }
            });
            console.log('yesyesyes', copyList);
          } else {
            copyList.forEach((i, indx) => {
              if (i.name === fixedList[indx].nameKey) {
                i.disabled = null;
                i.showValues = this.$t('否');
                if (i.name !== this.$t('使用批次参数')) {
                  i.actValue = parseFloat(fixedList[indx]['keyVal']);
                } else {
                  i.actValue = 0;
                }
              }
            });
            console.log('nononono', copyList);
          }

          const temDt = {
            ...this.mainfunc.dts,
            parameters: copyList
          };
          console.log('copytli', this.mainfunc);
          // this.fixedData = JSON.parse(JSON.stringify(temDt));
          // this.makeForms(temDt);
          this.passFuncs(val, 'no');
          this.makeForms(temDt);
          // console.log('copytli1111', temDt);
        }
      }, 100);
    },
    onCancel() {
      this.$emit('closemodal', 'close');
    }
  }
};
</script>

<style lang="scss" scoped>

::v-deep .search-form-box .el-form .el-form-item{
  min-height:32px;
  margin-bottom:0;
  height:auto;
}

::v-deep .search-form-box .el-form .el-form-item__content{
  min-height:32px;
  height:auto;
}

.asTit{
  padding:12px;
  height:56px;
  line-height:32px;
  color:#303133;
  font-size:16px;
}

.funcsForm{
  position: relative;
  padding:0 16px;
  border-top:1px solid #F0F0F0;
}

.app-main > div{
  background: #F5F7FA;
  padding:0;
}

.mainForm{
  ::v-deep .el-form{
    width:100% !important;
  }
  ::v-deep .el-radio-group{
    width:100%;
  }
  ::v-deep .el-form-item__label{
    float:none;
  }
  ::v-deep .el-form-item__content{
    margin-left:0 !important;
    width:100% !important;
    .el-input{
      width:inherit;
    }
  }
  ::v-deep .el-radio{
    height:22px !important;
    line-height:22px !important;
    width:37%;
  }
}

</style>
